import styled from 'styled-components';
import { Link } from 'react-router-dom';

import colors from 'themes/Main';

const { gray02, gray03, gray05 } = colors;

export const Container = styled.div`
  display: flex;
  align-items: center;
`;

export const PathLink = styled(Link)`
  font-size: 20px;
  color: ${gray05};
  text-decoration: none;
  transition: color 0.15s ease-in;

  &:hover {
    color: ${gray03};
  }

  &:not(:first-child) {
    margin-left: 20px;
  }

  &::after {
    content: '/';
    position: relative;
    font-size: 30px;
    top: 4px;
    left: 4px;
  }

  &:last-child {
    color: ${gray03};
    font-weight: 700;

    &::after {
      font-weight: bold;
    }

    &:hover {
      color: ${gray02};
    }
  }
`;
